import { isDefined } from 'utils/tsHelpers';
import { useWYSIWYGContext } from '../contexts/WYSIWYGContext';

export const useHandleImageInsert = () => {
  const { selectedImage, htmlEditorRef } = useWYSIWYGContext();

  return (attrs: Record<string, string>) => {
    if (isDefined(selectedImage)) {
      // update the existing image
      htmlEditorRef?.current?.dom.setAttribs(selectedImage, attrs);
      // important: if you don't call focus(), the change will appear in the UI, but will not be
      // reflected in the current value until another action is taken (like adding text)
      htmlEditorRef?.current?.focus();
    } else {
      const imgAttrs: Record<string, string> = { ...attrs, 'data-mce-id': '__mcenew' };
      // insert new content at the current selection/caret location
      htmlEditorRef?.current?.focus();
      htmlEditorRef?.current?.selection.setNode(
        htmlEditorRef?.current?.dom.create('img', imgAttrs),
      );
      // select the inserted image
      const insertedElm = htmlEditorRef?.current?.dom.select('img[data-mce-id="__mcenew"]')[0];
      // correct the selection range
      htmlEditorRef?.current?.selection.select(insertedElm);
      // clear the temporary selector
      htmlEditorRef?.current?.dom.setAttrib(insertedElm, 'data-mce-id', null);
    }
  };
};
